import { put, call, takeLatest } from 'redux-saga/effects';
import { base_url, endpoints } from '../../constants';
import { AxiosService } from '../../services';
import { actionTypes } from '../../types';
import { campaignListFailure, campaignListSuccess } from '../../actions/campaignActions/campaignListActions';
import store from '../../configStore';

function* campaignList({ payload }) {
    console.log('====================================');
    try {
        const response = yield call(AxiosService, {
            method: 'post',
            base_url: base_url,
            endPoint: endpoints.getCampaignListByStatus,
            payload: payload,
            isAuth: true,
        });
        console.log('====================================');
        console.log("CAMPAIGN_LIST_SUCCESS status :", response.data.status);
        console.log("CAMPAIGN_LIST_SUCCESS data :", response.data.response);
        console.log("CAMPAIGN_LIST_SUCCESS message :", response.data.message);
        console.log('====================================');
        yield put(
            campaignListSuccess({
                status: response?.data?.status,
                response: response?.data?.response,
                message: response?.data?.message
            })
        );
    } catch (error) {
        console.log('====================================');
        console.log("CAMPAIGN_LIST_FAILURE status :", error?.response?.status);
        console.log("CAMPAIGN_LIST_FAILURE data:", error?.response?.data);
        console.log("CAMPAIGN_LIST_FAILURE error :", error);
        console.log('====================================');
        yield put(campaignListFailure({
            status: error?.response?.data?.status,
            response: {},
            message: error?.response?.data?.message
        }));
    }
}

function* campaignListSaga() {
    yield takeLatest(actionTypes.CAMPAIGN_LIST_REQUEST, campaignList);
}

export default campaignListSaga;
